<template>
    <section class="form-success">
        <div class="text">
            <component
                class="title"
                :is="titleTag"
                v-test:title
            >
                {{ title }}
            </component>

            <markdown-content
                :content="text"
            />

            <div class="button">
                <b-button
                    variant="primary"
                    @click.prevent="$emit('back')"
                    v-test:submitAgainButton
                >
                    {{ $snippet('submit_again', 'submit again') }}
                </b-button>
            </div>
        </div>
    </section>
</template>

<script>
    import MarkdownContent from '../../utils/MarkdownContent/MarkdownContent';

    export default {
        name: 'form-success',

        components: {
            MarkdownContent,
        },

        props: {
            title: {
                type: String,
                required: true,
            },

            text: {
                type: String,
                required: true,
            },

            titleTag: {
                type: String,
                default: 'h1',
            },
        },
    };
</script>

<style lang="scss" scoped>
    .form-success {
        text-align: center;
        padding-top: 50px;
        padding-bottom: 28px;
    }

    .title {
        margin-bottom: 0;

        @include media-breakpoint-up(lg) {
            font-size: rem(64px);
            line-height: rem(76.8px);
            color: $black;
        }
    }

    .markdown-content ::v-deep {
        max-width: 775px;
        margin-left: auto;
        margin-right: auto;
        color: $black;
        font-size: rem(20px);
        line-height: rem(32px);

        p:not(:last-child) {
            margin-bottom: 2em;

            @include media-breakpoint-up(lg) {
                margin-bottom: 2.5em;
            }
        }
    }

    .button {
        margin-top: 50px;
        text-align: center;
    }

    .btn {
        min-width: 140px;
    }
</style>
